<template>
  <div class="department-dialog">
    <el-form :model="ruleForm" :hide-required-asterisk="false" label-width="120px" size="mini" label-position="right" ref="ruleForm" @submit.native.prevent :rules="rules" :disabled="$permission('岗位管理-更新岗位分类')">
      <el-form-item label="分组名称：" prop="job_type_name">
        <el-input v-model="ruleForm.job_type_name" placeholder="请输入职位分类名称" maxlength="20" clearable></el-input>
      </el-form-item>
      <el-form-item label="分组描述：" prop="job_type_desc">
        <el-input v-model="ruleForm.job_type_desc" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入职位分类描述" maxlength="120" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="职位负责人：" prop="depart_header">
        <el-select v-model="ruleForm.depart_header" filterable remote clearable reserve-keyword placeholder="搜索：姓名 / 邮箱 / 手机号 / 职称" :remote-method="remoteMethod" :loading="searchLoading">
          <el-option v-for="item in leaderList" :key="item.uid" :label="item.realname" :value="item.uid">
          </el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div class="footer-btns">
      <div>
        <wf-button type="danger" plain @click="del" v-if="isEdit" v-permission="'岗位管理-删除岗位分类'">删除分组</wf-button>
      </div>
      <div>
        <wf-button style="margin-right:14px;" type="primary" @click="submitForm" :loading="btnLoading" v-permission="'岗位管理-更新岗位分类'">确 定</wf-button>
        <wf-button plain @click="$emit('cancel')">取 消</wf-button>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api/jobLevel/jobLevel'
export default {
  props: {
    dataset: {
      type: Object,
      default: () => { }
    },
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isParent: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  data() {
    return {
      ruleForm: {
        job_type_desc: '',
        job_type_name: '',
        job_type_id: '',
        pid: 0
      },
      btnLoading: false,
      searchLoading: false,
      leaderList: [],
      departmentType: [],
      rules: {
        job_type_name: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        // job_type_desc: [{ required: true, message: '此项不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init() {
      if (this.isEdit) {
        let { job_type_desc, job_type_name, id } = this.dataset
        this.ruleForm = { job_type_desc, job_type_name, job_type_id: id }
      } else {
        this.resetForm()
        // let { id } = this.dataset
        // this.ruleForm.pid = id || 0
      }
    },
    submitForm() {
      this.btnLoading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm))
          if (this.isEdit) {
            api.jobTypeUpdate(params).then(res => {
              this.$emit('complete')
              this.$message({ message: '职位分类更新成功', type: 'success' });
              this.btnLoading = false
            }).catch(err => {
              this.btnLoading = false
            })
          } else {
            api.jobAddMsg(params).then(res => {
              this.$emit('complete')
              this.$message({ message: '职位分类新增成功', type: 'success' });
              this.btnLoading = false
            }).catch(err => {
              this.btnLoading = false
            })
          }
        } else {
          this.btnLoading = false
          return false;
        }
      });
    },
    async del() {
      await this.$wfAlert('warning', '确定删除此分组吗？','删除后不可恢复。' )
      await api.jobTypeDelete({ job_type_id: this.ruleForm.job_type_id })
      this.$emit('delete', this.dataset.id)
      this.$message({ message: '删除成功', type: 'success' });
    },
    resetForm() {
      this.ruleForm = {
        job_type_desc: '',
        job_type_name: '',
        job_type_id: '',
        pid: 0
      }
      this.$refs.ruleForm.clearValidate()
    },
  }
}
</script>
<style lang="scss">
.department-dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .footer-btns {
    text-align: right;
  }
  .el-input__inner {
    width: 100%;
  }
  .el-form-item__content {
    > div:nth-child(1) {
      width: 100%;
    }
  }
}
</style>
